class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close, .cart-notification__links > button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHtml = parsedState.sections && parsedState.sections[section.id];
      if (!target || !sectionHtml) return;
      const content = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (content !== null) target.innerHTML = content;
    });

    this.refreshCustomCartCount();
    if (this.header) this.header.reveal();
    this.open();
  }

  refreshCustomCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to refresh cart count');
        return response.json();
      })
      .then((cart) => {
        document.querySelectorAll('[data-cc-cart-count]').forEach((node) => {
          node.dataset.count = cart.item_count;
          node.textContent = cart.item_count > 0 ? cart.item_count : '';
          node.style.display = cart.item_count > 0 ? '' : 'none';
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(() => {});
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const selected = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return selected ? selected.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
